import { createSelector } from 'reselect';

const selectCart = state => state.cartReducer;   //root reducers




export const selectCartItems = createSelector(
   [selectCart],
   cart => cart.cartItems
);
export const selectRefundItems = createSelector(
   [selectCart],
   cart => cart.refundItems
);
export const selectCartHidden = createSelector(
   [selectCart],
   cart => cart.hidden

)


export const selectCartItemsCount = createSelector(
   [selectCartItems],  //refencing this means we are trying to get the cartItems from selectCartItems
   cartItems => cartItems?.reduce(
      (accumulatedQuantity, cartItem) => accumulatedQuantity + cartItem.quantity, 0
   )
);



export const selectCartTotal = createSelector(
   [selectCartItems],  //refencing this means we are trying to get the cartItems from selectCartItems
   cartItems => cartItems.reduce(

      (accumulatedQuantity, cartItem) => accumulatedQuantity + cartItem.quantity * cartItem.salesPrice, 0

   )
);

export const selectCartRefundTotal = createSelector(
   [selectRefundItems],  //refencing this means we are trying to get the cartItems from selectCartItems
   refundItems => refundItems?.reduce(

      (accumulatedQuantity, refundItem) => accumulatedQuantity + refundItem.quantityRefunded * refundItem.amount, 0

   ) ?? 0
);







//to use selector , install selector  and then write your selector js file and then go to your component and use it
